import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Languages } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { vertaalTeksten } from "@/lib/cms";

export const LANGS = ["nl", "en", "de", "fr"];

/** Meertalig tekstveld (NL leidend) met AI-vertaalknop. */
export const TextField = ({ label, value = {}, onChange, rows = 0 }) => {
  const [busy, setBusy] = useState(false);
  const nl = (value?.nl || "").trim();

  const vertaal = async () => {
    if (!nl || busy) return;
    setBusy(true);
    try {
      const res = await vertaalTeksten([{ sleutel: "veld", nl }]);
      const v = res.veld || {};
      onChange({ ...value, en: v.en || value.en || "", de: v.de || value.de || "", fr: v.fr || value.fr || "" });
      toast.success(`"${label}" vertaald naar EN, DE en FR`);
    } catch (e) {
      toast.error(e.message || "Vertalen mislukt");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between gap-2">
        <Label className="text-xs uppercase tracking-wide text-muted-foreground">{label}</Label>
        <Button type="button" variant="ghost" size="sm" onClick={vertaal} disabled={!nl || busy} title={nl ? "Vertaal het Nederlands naar EN, DE en FR" : "Vul eerst de Nederlandse tekst in"} data-testid={`translate-${label}`}>
          {busy ? <Loader2 className="mr-1 h-3.5 w-3.5 animate-spin" /> : <Languages className="mr-1 h-3.5 w-3.5" />}
          Vertaal NL
        </Button>
      </div>
      <div className="grid gap-2 sm:grid-cols-2">
        {LANGS.map((l) => (
          <div key={l}>
            <span className="text-[11px] font-medium uppercase text-muted-foreground">{l}{l === "nl" ? " *" : ""}</span>
            {rows > 0 ? (
              <Textarea rows={rows} value={value?.[l] || ""} onChange={(e) => onChange({ ...value, [l]: e.target.value })} data-testid={`field-${label}-${l}`} />
            ) : (
              <Input value={value?.[l] || ""} onChange={(e) => onChange({ ...value, [l]: e.target.value })} data-testid={`field-${label}-${l}`} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
